<script>
    /**
     * 下拉选择
     */
    import { hideOptsMixin } from '../mixin';
    import NormalScrollbar from './NormalScrollbar';

    export default {
        mixins: [hideOptsMixin],
        name: 'diy-drop-down',
        data () {
            return {
                droped: false,
                dropX: 0,
                dropY: 0,
                dropR: 0,
                hovering: false,
                minWidth: 1
            };
        },
        computed: {
            curStyle () {
                return {
                    'margin-left': this.marginLeft * this.$cStyle.horizonMargin + 'px',
                    'margin-right': this.marginRight * this.$cStyle.horizonMargin + 'px',
                    'float': this.float
                };
            },
            dropStyle () {
                const style = {
                    top: this.dropY + 'px',
                    position: this.position
                };
                if (this.dropR) {
                    style.right = `${this.dropR}px`;
                } else {
                    style.left = `${this.dropX}px`;
                }
                return style;
            },
            computedSelected () {
                return this.text || (typeof this.selected !== 'object' ? this.selected : this.selected.text);
            }
        },
        props: {
            optCls: {
                default: '',
                required: false
            },
            text: {
                default: '',
                required: false
            },
            selected: {
                default: null,
                required: false
            },
            theme: {
                default: 'grey',
                required: false
            },
            marginLeft: {
                default: 0,
                required: false
            },
            marginRight: {
                default: 0,
                required: false
            },
            float: {
                default: 'left',
                required: false
            },
            disabled: {
                type: Boolean,
                default: false,
                required: false
            },
            position: {
                default: 'absolute',
                required: false
            },
            widthOpts: {
                default: 0,
                required: false
            },
            heightOpts: {
                default: 300,
                required: false
            }
        },
        methods: {
            drop () {
                if (this.disabled === true) {
                    return false;
                }
                if (this.droped) {
                    this.fold();
                    return;
                }
                this.droped = true;
                var that = this;
                var rect = this.$el.getBoundingClientRect();
                this.dropX = Math.round(rect.left) + (this.position === 'absolute' ? window.pageXOffset : 0);
                this.dropY = Math.round(rect.top) + Math.round(rect.height + 8) + (this.position === 'absolute' ? window.pageYOffset : 0);
                this.minWidth = Math.round(rect.width) - 28 - 2;
                var limitWidth = document.documentElement.clientWidth;
                this.dropR = 0;
                if (limitWidth - (this.dropX + rect.width) < 80) {
                    this.dropX = 0;
                    this.dropR = limitWidth - Math.round(rect.right) - (this.position === 'absolute' ? window.pageXOffset : 0);
                }
                this.$nextTick(() => {
                    const optWidth = this.$refs.optionList.getBoundingClientRect().width;
                    // optWidth
                    if (this.dropR) {
                        this.dropR -= (optWidth / 2 - rect.width / 2);
                    } else {
                        this.dropX -= (optWidth / 2 - rect.width / 2);
                    }
                });
                this.outAreaMouseDown = function () {
                    if (that.hovering) {
                        return;
                    }
                    that.fold();
                };
                window.addEventListener('mousedown', this.outAreaMouseDown);
                this.$emit('show');
            },
            fold () {
                this.droped = false;
                window.removeEventListener('mousedown', this.outAreaMouseDown);
                this.$emit('hide');
            },
            emptyFunc () {
            }
        },
        beforeDestroy () {
            document.body.removeChild(this.$refs.optionList);
        },
        mounted () {
            document.body.appendChild(this.$refs.optionList);
        },
        components: {NormalScrollbar}
    };
</script>

<template>
    <div class="drop-frame diy-drop-down"
         @click.stop="drop"
         @mouseenter="hovering = true"
         @mouseleave="hovering = false"
         v-bind:class="[theme, {disabled: disabled}]"
         v-bind:style="curStyle">
        <div class="selected" v-if="text" v-html="computedSelected"></div>

        <transition name="fade">
            <div class="option-list"
                 :class="optCls"
                 @mousedown.stop="emptyFunc"
                 ref="optionList"
                 v-show="droped && $slots.default"
                 v-bind:style="dropStyle">
                <normal-scrollbar :height="heightOpts">
                    <slot></slot>
                </normal-scrollbar>
            </div>
        </transition>
    </div>
</template>

<style lang="less" scoped>
    @import '../../assets/less/widgets-var.less';

    .drop-frame.no-border {
        /*display: inline-block;*/
        border-color: transparent;

        > .selected {
            padding: 0 23px 0 0px;
            font-size: 14px;
            font-family: cmsicon;
        }
    }

    .drop-frame {
        width: auto;
        min-width: 1px;
        height: @widgetsHeight;
        line-height: @widgetsHeight;
        margin: (@lineHeight - @widgetsHeight)/2 0;
        position: relative;
        cursor: pointer;

        > .selected {
            width: auto;
            min-width: 1px;
            height: @widgetsHeight;
            line-height: @widgetsHeight + 1;
            text-align: center;
            overflow: hidden;
            padding: 0 30px 0 15px;
            margin: 0;
            position: relative;
            font-size: 14px;
            cursor: pointer;
            position: relative;
            font-family: cmsicon;
        }

        & :after {
            content: "";
            width: 0;
            height: 0;
            position: absolute;
            right: 12px;
            top: 15px;
            border-top: 7px @otherTextClr solid;
            border-right: 4px #fff solid;
            border-left: 4px #fff solid;
        }
    }

    .option-list {
        background-color: #fff;
        box-shadow: 0px 0px 4px 0px rgba(17, 6, 85, 0.16);
        width: auto;
        height: auto;
        min-width: 1px;
        min-height: 1px;
        overflow: hidden;
        z-index: 20000;
        border-radius: @widgetsBorderRadius;

        .item-wrap {
            padding: 6px 0;
        }

        .item {
            width: auto;
            min-width: 1px;
            overflow: hidden;
            clear: both;
            margin: 0;
            height: @widgetsHeight;
            line-height: @widgetsHeight;
            padding: 0 14px;
            font-size: 14px;
            color: @otherTextClr;
            cursor: pointer;

            &.disabled {
                color: @otherBtnBorderNoteClr;
                cursor: not-allowed;

                .label {
                    cursor: not-allowed;
                }
            }

            &.active {
                color: @primaryBg;
            }

            .label {
                margin: 0;
            }

            &.is-button {
                &:first-child {
                    /*margin-top: 6px;*/
                    border-top: 1px solid @otherBorderClr;
                }
            }

        }

        .item:hover {
            background-color: @otherBtnHoverClr;
        }


    }
</style>
